import type { z } from 'zod'

type NonNullableFallback<SchemaT extends z.ZodType> = NonNullable<
  z.infer<SchemaT>
>

/**
 * Will return a schema that will fallback to the provided value if the validated value is null or undefined
 * @param schema
 * @param fallback
 * @returns
 */
export const wrapWithNonNullFallback = <TSchema extends z.ZodType>(
  schema: TSchema,
  fallback: NonNullableFallback<TSchema>
) => {
  return schema.transform(
    (validatedValue): NonNullableFallback<TSchema> =>
      validatedValue === null || validatedValue === undefined
        ? fallback
        : (validatedValue as NonNullableFallback<TSchema>)
  )
}
